import request from '@/utils/request'

// 获取角色店铺列表（按 roleId 查已关联店铺，不能带当前登录 shopId，否则其它店铺关联后列表为空）
export function getRoleShopList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/roleShop.listRoleShop',
      method: 'get',
      params: {
        ...params
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取未关联的店铺列表
export function getNoRoleShops(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/org.listOrgNoShops',
      method: 'get',
      params: {
        ...params,
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 关联店铺到角色
export function saveRoleShop(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/roleShop.saveRoleShop',
      method: 'post',
      data: {
        ...data,
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 取消店铺关联（按 rcId 删除，勿覆盖为当前登录 shopId）
export function deleteRoleShop(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/roleShop.deleteRoleShop',
      method: 'post',
      data: {
        ...data
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}